export default "__VITE_ASSET__CRgAXQWv__"